import React from "react";

import casaAluguel from "../../assets/images/casaAluguel.png";
import casaRemota from "../../assets/images/casaRemota.png";
import solVerde from "../../assets/images/solVerde.png";
import solVermelho from "../../assets/images/solVermelho.png";

export function SolCasaFatura(props) {
    const fatura = props.fatura;

    if (!fatura) return null;

    const importacaoSolarPendente = parseFloat(fatura.quantidade_geracao || 0) <= 0;
    const elementoSol = importacaoSolarPendente ? (
        <img alt="" title="Importação Solar Pendente" height={24} style={{ marginBottom: 6, marginRight: 3 }} src={solVermelho} />
    ) : (
        <img alt="" title="Geração Solar Importada" height={24} style={{ marginBottom: 6, marginRight: 3 }} src={solVerde} />
    );

    if (fatura.geradora_e_remota && fatura.possui_contrato_aluguel) {
        return (
            <div title={`Geradora que aluga energia de outra usina`}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {elementoSol}
                    <img alt="" height={24} style={{ marginBottom: 6 }} src={casaAluguel}></img>
                </div>

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <span> -{fatura.geradora_externa ? " G. Ext" : " FV " + fatura.sequencia_uc_geradora}</span>
                </div>
            </div>
        );
    }
    if (fatura.geradora_e_remota && !fatura.possui_contrato_aluguel) {
        return (
            <div title={`Geradora que recebe energia de outra usina própria`}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {elementoSol}
                    <img alt="" height={24} style={{ marginBottom: 6 }} src={casaRemota}></img>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <span> -{fatura.geradora_externa ? " G. Ext" : " FV " + fatura.sequencia_uc_geradora}</span>
                </div>
            </div>
        );
    }

    if (!fatura.geradora_e_remota && fatura.unidade_geradora) {
        return (
            <div title={"Unidade Consumidora Geradora"} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                {elementoSol}
                <span> - FV{fatura.sequencia_uc_geradora}</span>
            </div>
        );
    }

    if (!fatura.geradora_e_remota && fatura.unidade_remota) {
        return (
            <div title={"Unidade Consumidora Remota"} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img alt="" height={24} style={{ marginBottom: 6 }} src={casaRemota}></img>
                <span> -{fatura.geradora_externa ? " G. Ext" : " FV " + fatura.sequencia_uc_geradora}</span>
            </div>
        );
    }

    if (fatura.unidade_remota && fatura.possui_contrato_aluguel) {
        return (
            <div title={"Unidade Consumidora Remota que aluga energia"} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img alt="" height={24} style={{ marginBottom: 6 }} src={casaAluguel}></img>
            </div>
        );
    }

    return null;
}
